/* eslint-disable */
import React from 'react';
import {
    getBackgroundImg,
    getPublicImagePath,
    getUploadedImagePath,
    useAppState,
    useBreakpoints
} from '@nutastic/nutastic-react-app';
import { Swiper, SwiperSlide } from 'swiper/swiper-react.cjs';
import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
import HighlightBox from "../HighlightBox";
import {useNavigation} from "../../hooks/useNavigation";
import {BANNER_SWIPER_PROPS, CONSTANTS, COVER_SWIPER_PROPS} from "../../utils/constants";
import {BarsOutlined} from "@ant-design/icons";
import classnames from "classnames";
import Footer from "../Footer";

SwiperCore.use([Navigation, Autoplay, EffectFade, Pagination]);

const componentClass = 'home-page';

const HomePage = () => {
    const { pages: { homePage } } = useAppState();
    const { lg: isLargeScreen, xl: isXtraLargeScreen } = useBreakpoints();
    const { loadPage } = useNavigation();
    const isReadyToRender = isLargeScreen !== undefined;
    const { slides, sliderSections, welcomeMessage, highlight1, highlight2, highlight3, highlight4, highlight5 } = homePage;

    return <main className={componentClass} id="homeBase">
        <div className="bannerSlideshow">
            { isReadyToRender && <Swiper className="banners" { ...BANNER_SWIPER_PROPS } slidesPerView={ isLargeScreen ? 1.4 : 1.1 }>
                {
                    (slides || []).map( (slide, i) => {
                        const { image, title, text, urlType, url } = slide;
                        const onBannerClick = () => {
                            if(urlType === 'external') {
                                window.open(url, '_blank').focus();
                            } else if(url) {
                                loadPage(url);
                            } else {
                                console.warn(`Invalid url configured for banner ${i}`);
                            }
                        };

                        return <SwiperSlide>
                            <div className="banner" onClick={onBannerClick}>
                                <img
                                    src={ getPublicImagePath('transparent-wide.png') }
                                    style={ getBackgroundImg(getUploadedImagePath(image)) }
                                    alt={title}
                                />
                                <div>
                                    <h4>{ title }</h4>
                                    <p>{ text }</p>
                                </div>
                                <span />
                            </div>
                        </SwiperSlide>
                    })
                }
            </Swiper> }
        </div>

        {
            (sliderSections || []).filter(s => s.hasOwnProperty('enableField') && s.enableField !== 'false').map((section, i) => {
                const { title, description, sliderItems, type, url } = section;
                const largeScreenSlidesPerView = type === CONSTANTS.APPKEY_SHOP || type === CONSTANTS.APPKEY_NEWS ? isXtraLargeScreen ? 2.75 : 1.75 : 3.25;
                const slidesPerView = isLargeScreen ? largeScreenSlidesPerView : type === CONSTANTS.APPKEY_SHOP || type === CONSTANTS.APPKEY_NEWS ? 1.25 : 1.5;
                const squareSlidesPerView = isLargeScreen ? 4.25 : 2.5;
                const useSquareSize = type === CONSTANTS.APPKEY_AUDIO_SERIES;
                return <section className="featuredSection">
                    <h2>{ title }</h2>
                    <p>{ description }</p>
                    { url && <div className="sectionActionButton" onClick={() => loadPage(url)}><BarsOutlined /></div> }
                    <Swiper className="featuredSection__slider" { ...COVER_SWIPER_PROPS } slidesPerView={useSquareSize ? squareSlidesPerView : slidesPerView}>
                        {
                            sliderItems.map((item, i) => {
                                const { slug, image, title, field_1: shortDesc, excerpt: productShortDesc, field_7: price } = item;
                                const urlToLoad = type === CONSTANTS.APPKEY_SHOP ? `/shop/${slug}` : `/content/${type}/${slug}`;
                                const subtext = type === CONSTANTS.APPKEY_SHOP ? productShortDesc : shortDesc;
                                const priceTag = type === CONSTANTS.APPKEY_SHOP ? <span className="priceTag">${ price }</span> : null;
                                const itemClasses = classnames(null, {
                                    featureItem: type !== CONSTANTS.APPKEY_NEWS && type !== CONSTANTS.APPKEY_SHOP,
                                    featureArticle: type === CONSTANTS.APPKEY_NEWS || type === CONSTANTS.APPKEY_SHOP
                                });
                                return <SwiperSlide key={i}>
                                    <div className={itemClasses} onClick={ () => loadPage(urlToLoad) }>
                                        <img src={getUploadedImagePath(image)} alt={title}/>
                                        { type === CONSTANTS.APPKEY_NEWS || type === CONSTANTS.APPKEY_SHOP ?
                                            <div><h4>{ title }</h4><p>{ subtext }</p>{priceTag}</div>
                                            :
                                            <div><p>{ title }</p></div>
                                        }
                                    </div>
                                </SwiperSlide>
                            })
                        }
                    </Swiper>
                </section>;
            })
        }

        <div className="highlightsSection" >
            <p>{ welcomeMessage }</p>
            <div className="highlights">
                <HighlightBox url={highlight1?.url} image={highlight1?.image} title={highlight1?.title} isExternalUrl={highlight1?.urlType === 'external'} />
                <div className="highlights__box">
                    <HighlightBox url={highlight2?.url} isSmall={true} image={highlight2?.image} title={highlight2?.title} isExternalUrl={highlight2?.urlType === 'external'} />
                    <HighlightBox url={highlight3?.url} isSmall={true} image={highlight3?.image} title={highlight3?.title} isExternalUrl={highlight3?.urlType === 'external'} />
                </div>
                <HighlightBox url={highlight4?.url} image={highlight4?.image} title={highlight4?.title} isExternalUrl={highlight4?.urlType === 'external'} />
                <HighlightBox url={highlight5?.url} image={highlight5?.image} title={highlight5?.title} isExternalUrl={highlight5?.urlType === 'external'} />
            </div>
            <span className="fadedFooter" />
        </div>

        <Footer />
    </main>;
};

export default HomePage;
